import { makeStyles } from "@material-ui/core/styles";
import ScrollAnimation from "react-animate-on-scroll";
import Typography from "@material-ui/core/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles((theme) => ({
  // footer background
  footerBack: {
    background: "#0f0f0f",
    height: "auto",
    width: "100%",
    borderRadius: "4px",
    marginTop: "50px",
  },
  footerBox: {
    margin: "25px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1",
    position: "relative",
  },
  // footer heading text
  contactsHeader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textAlign: "left",
    position: "relative",
    marginTop: "30px",
    marginBottom: "30px",
    fontSize: "calc(20px + 2vw)",
    fontWeight: "100",
  },
  contactLine: {
    marginLeft: "40px",
    marginRight: "40px",
    color: "#2f2f2f",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  footerLogo: {
    marginRight: "10px",
    height: "calc(25px + 2vw)",
    filter: "invert(1)",
    width: "calc(25px + 2vw)",
  },
  footerIcons: {
    marginRight: "10px",
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <ScrollAnimation offset={50} animateIn="fadeInUp">
      <footer className={classes.footerBox}>
        <div id="footer" className={classes.footerBack}>
          <div>
            <Typography className={classes.contactsHeader} variant="h3">
              <svg
                className={classes.footerLogo}
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="500.000000pt"
                height="485.000000pt"
                viewBox="0 0 500.000000 485.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,485.000000) scale(0.100000,-0.100000)"
                  fill="#000000"
                  stroke="none"
                >
                  <path
                    d="M870 4396 c-439 -384 -712 -854 -824 -1416 -122 -615 -1 -1274 332
                -1803 134 -213 337 -448 516 -596 l76 -62 0 1500 c0 928 4 1501 9 1501 6 0 36
                -14 68 -31 150 -81 190 -103 363 -194 102 -54 199 -105 215 -115 17 -10 89
                -48 160 -86 72 -37 170 -89 219 -116 l89 -48 904 0 903 0 0 -460 0 -460 -900
                0 -900 0 0 -989 0 -988 32 -7 c89 -18 291 -28 453 -23 655 21 1248 284 1710
                758 390 400 630 913 694 1479 14 124 6 505 -13 623 -76 469 -248 859 -536
                1216 -108 134 -407 421 -411 394 -1 -4 -1 -73 1 -151 1 -79 -1 -166 -5 -193
                l-7 -49 -1524 0 -1524 0 -2 200 -3 199 -95 -83z"
                  />
                </g>
              </svg>
              Fryvoker design
            </Typography>
          </div>
          <div>
            <hr className={classes.contactLine}></hr>
          </div>
          <div className="footerLinkBox">
            <div>
              <a className="footerLinks" href="https://vk.com/emptied_head">
                <FontAwesomeIcon
                  icon={["fab", "vk"]}
                  className={classes.footerIcons}
                />
                VK
              </a>
            </div>
            <div>
              <a className="footerLinks" href="https://t.me/Fryvoker">
                <FontAwesomeIcon
                  icon={["fab", "telegram"]}
                  className={classes.footerIcons}
                />
                Telegram
              </a>
            </div>
            <div>
              <a
                className="footerLinks"
                href="https://discordapp.com/users/522687034243153922/"
              >
                <FontAwesomeIcon
                  icon={["fab", "discord"]}
                  className={classes.footerIcons}
                />
                Discord
              </a>
            </div>
            <div>
              <a className="footerLinks" href="mailto:magerovsky.d@gmail.com">
                <FontAwesomeIcon
                  icon={["fas", "envelope"]}
                  className={classes.footerIcons}
                />
                Gmail
              </a>
            </div>
          </div>
          <p className="copyright">
            © Copyright. All rights to works on this site belongs to Fryvoker
            design 2021-{new Date().getFullYear()}.
          </p>
          <p className="designed">
            Designed and created by 
            <a className="link" href="https://tslashdreamy.github.io/#/">
              /TSlash
            </a>
             ©
          </p>
        </div>
      </footer>
    </ScrollAnimation>
  );
};

export default Footer;
